import React, { useCallback, useEffect, useState } from "react";
import { ACTIONS } from "../../../../constants/Constants";
import { t, use } from "i18next";
import CustomCheckBox from "../../../Hospital/components/HeaderFileChecks/CustomCheckBox";
import {
  Checkbox,
  ComboBox,
  DirectionalHint,
  Dropdown,
  SelectableOptionMenuItemType,
  TooltipDelay,
  TooltipHost,
} from "@fluentui/react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";


const ConfigurePacsAccess = (props) => {

  const handleAllPacsCheckBoxClick = (event, isChecked) => {
    props.setCheckAllPacs(isChecked);

    if (isChecked) {
      const allPacsIds = props.availablePacsList?.map((pacs) => pacs.id);
      props.setSelectedPacsList(allPacsIds);
    } else {
      props.setSelectedPacsList([]);
    }
  };

  const handlePacsCheckBoxClick = (id, isChecked) => {
    let updatedSelectedPacsList = [...props.selectedPacsList];
    if (isChecked) {
      updatedSelectedPacsList.push(id);
    } else {
      updatedSelectedPacsList = updatedSelectedPacsList.filter(pacsId => pacsId !== id);
    }
    props.setSelectedPacsList(updatedSelectedPacsList);
  };

  useEffect(()=>{
    const allSelected = props.selectedPacsList?.length === props.availablePacsList?.length;
    props.setCheckAllPacs(allSelected);
  }, [props.selectedPacsList])

  const tooltipStyle = {
    root: 'pacs-config-text',
  };

  return (
    <>
      <div className="tab-section">
        {props.action !== ACTIONS.VIEW && (
          <>
            <section className="sectionA">
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  padding: "0px 0px",
                  marginBottom: "20px"
                }}
              >
                Configure PACS Access
              </p>
            </section>

            {/* SELECT ALL  */}
            {props.availablePacsList?.length > 0 && (
              <div className="ms-Grid-row" dir="ltr">
                <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                  <Checkbox
                    label="Select All"
                    onChange={handleAllPacsCheckBoxClick}
                    id="all"
                    checked={props.checkAllPacs == true}
                  />
                </div>
              </div>
            )}
            {props.availablePacsList?.length == 0 && (
              <>
                <span>No PACS available</span>
              </>
            )}
            <div className="ms-Grid-row" dir="ltr">
              {props.availablePacsList?.map((pacs, index) => {
                return (
                  <div
                    key={index}
                    className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4"
                  >
                    <div
                      className="ms-sm12 ms-md8 ms-lg6 ms-xl10"
                      style={{
                        display: "block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Checkbox
                        key={pacs.id}
                        label={pacs.name}
                        name={pacs.name}
                        onChange={(e, isChecked) =>
                          handlePacsCheckBoxClick(+pacs.id, isChecked, {
                            key: 0,
                          })
                        }
                        checked={props.selectedPacsList.includes(pacs.id)}
                      />
                    </div>

                  </div>
                );
              })}
            </div>
          </>
        )}

        {props.action === ACTIONS.VIEW && (
          <>
            <section className="sectionA">
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  padding: "0px 0px",
                  marginBottom: "20px",
                }}
              >
                Configured PACS Access
              </p>
            </section>

            {props.selectedPacsList?.length == 0 && (
              <>
                <span>No PACS configured</span>
              </>
            )}

            <div className="ms-Grid" dir="ltr">
              {props.availablePacsList?.map((pacs) => {
                return (
                  <>
                    {!!props.selectedPacsList?.includes(pacs.id) && (
                      <div className="ms-Grid-row" dir="ltr">
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                          <span style={{ wordBreak: "break-word" }}><CustomToolTipHost styles={tooltipStyle} content={pacs.name} id={"tooltip_"}>{pacs.name}</CustomToolTipHost></span>
                        </div>

                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ConfigurePacsAccess;
